module.exports = __webpack_public_path__ + "static/media/poste_25.81f2a1f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_25.jpg
// module id = 254
// module chunks = 0